import { useIsomorphicLayoutEffect } from 'react-use';

import { usePrivateWorkspaceAgentPanelPillClips } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPillClipsProvider';
import { type WorkspaceAgentMessagePill } from '~/components/v2/components/workspace/workspace-agent-panel/schemas/pillMetadata';
import { flattenWorkspaceAgentAssetPillItems } from '~/components/v2/components/workspace/workspace-agent-panel/utils/flattenWorkspaceAgentAssetPillItems';

/**
 * The clips provider batched history before hydrated rows existed. Register the pills (for
 * `@[asset:…]` covers) and version ids before paint so the widened batch is in flight instead of
 * every member reading as missing.
 */
export const useRegisterWorkspaceAgentAssetPillClipIds = (pills: readonly WorkspaceAgentMessagePill[]) => {
  const { registerClipIds, registerPills } = usePrivateWorkspaceAgentPanelPillClips();

  useIsomorphicLayoutEffect(() => {
    for (const pill of pills) {
      if (pill.type !== 'asset' && pill.type !== 'assetList') {
        continue;
      }

      registerPills(pill.id, [pill]);

      const clipIds = flattenWorkspaceAgentAssetPillItems([pill]).flatMap((item) => (item.clipId ? [item.clipId] : []));

      if (clipIds.length > 0) {
        registerClipIds(pill.id, clipIds);
      }
    }
  }, [pills, registerClipIds, registerPills]);
};
